import React from 'react';
import { withLoading } from '@front-activerse/common-components';
import TrackerAddEditMeal from '../components/TrackerAddEditMeal';
import UniversalPlaceholder from '../../Layout/UniversalPlaceholder';
import { normalizeCookbookMeal } from '../helpers/normalizers';
import { CookbookMealProps } from '../types';

const TrackerAddCookbookMealContainer: React.FC<CookbookMealProps & { dietMealId?: string }> = (
  props
) => {
  const normalizedProps = normalizeCookbookMeal(props);
  sessionStorage.setItem('tracker_depth', '1');
  return (
    <TrackerAddEditMeal
      key={normalizedProps.mealData.id}
      {...normalizedProps}
      dietMealId={props.dietMealId}
    />
  );
};

export default withLoading(TrackerAddCookbookMealContainer, UniversalPlaceholder);
